module.exports = __webpack_public_path__ + "static/media/process-legal.902354af.png";